import React from 'react'
import ReactGA from 'react-ga'
import { useMediaQuery } from 'react-responsive'
import { configureAnchors } from 'react-scrollable-anchor'

import Menu from '../components/menu'
import Home from './Home'

ReactGA.initialize('UA-140311953-3')
ReactGA.pageview(window.location.pathname + window.location.search)

function App() {
  const isLgScreen = useMediaQuery({ minDeviceWidth: 750 })
  configureAnchors({ offset: isLgScreen ? -60 : -150 })
  return (
    <div className="layout">
      <Menu />
      <div className="layout-content">
        <div className="header">
          <h1>Stardew Valley</h1>
          <h5>Bundle Tracker</h5>
        </div>
        <Home />
      </div>
    </div>
  )
}

export default App
